<style lang="less">

</style>
<template>
	<div>
		<v-hover v-slot:default="{ hover }" close-delay="100" open-delay="100"  >
			<div style="position: relative;" :id="element.id">
				<div class="editorElement">
					<component v-bind:is="element.component" :element="element" :focus="focus" v-on:focus="(f) => {$emit('focus', f)}" v-on:delete="deleteA">
						<template v-slot:element="slotProps">
							<EditorElement :element="slotProps.childElement" :focus="focus" v-on:delete="(child) => { deleteElem( child, element) }"  v-on:focus="(f) => {$emit('focus', f)}"></EditorElement>
						</template>						
					</component>
					<EditorToolbar v-if="focus == element" :element="element" v-on:delete="$emit('delete', element)"></EditorToolbar>
				</div>
				<v-btn fab color="#F5F5F5" x-small class="focusButton" v-if="!(focus == element) && hover" @click="$emit('focus', element)"><v-icon color="grey" x-small>mdi-cursor-default</v-icon></v-btn>
				<v-btn x-small fab class="focusButton" @click="$emit('focus', false )" v-if="focus == element"><v-icon color="grey" x-small>mdi-close</v-icon></v-btn>
			</div>
		</v-hover>
	</div>
</template>

<script>
	export default {
		name: "EditorElement",
		props:{
			element: {type: Object},
			focus: { type: Object }, 
		}, 
		data: () =>{
			return {				
			}
		},
		components: {
			EditorElement: () => import("../TextEditor/EditorElement"),
			EditorCard:  () => import("../TextEditor/EditorCard"),
			EditorHtml:  () => import("../TextEditor/EditorHtml"),
			EditorRow:  () => import("../TextEditor/EditorRow"),
			EditorText:  () => import("../TextEditor/EditorText"),
			EditorHr:  () => import("../TextEditor/EditorHr"),
			EditorButton:  () => import("../TextEditor/EditorButton"),
			EditorToolbar:  () => import("../TextEditor/EditorToolbar"),
		},
		computed: {
		},
		methods: {
			deleteElem(child, element ){
				element.elements.splice( element.elements.indexOf(child), 1 )
				this.$emit('focus', element)
			}
		}
	}
</script>